import { ReactElement } from 'react';
import { NullableString } from '@root/src/app/common/types';
import { ButtonsI } from './actionButtons';
import ContextMenu from '@designSystem/contextMenu/contextMenu';
import getActionOptions from './actionOptions';
import { HandlersI } from './actions';
import ThreeDotsButton from './threeDotsButton';
import GenerateCertificateDropdownMenuButton from './generateCertificateDropdownButton';
import useFeatureFlagsHealthcheck from '@app/featureFlagHealthcheck/useFeatureFlagsHealthcheck';

const ActionsDesktop = ({
  state,
  testType,
  buttons,
  isCertificateGenerated,
  isResendCertificate,
  isCertificateTypeDropdownShow,
  handlers,
  showPreviousStageAndGenerateCertificateButtons,
}: {
  state: string;
  testType: NullableString;
  buttons: ButtonsI;
  isCertificateGenerated: boolean;
  isResendCertificate: boolean;
  isCertificateTypeDropdownShow: boolean;
  handlers: HandlersI;
  showPreviousStageAndGenerateCertificateButtons: boolean;
}): ReactElement => {
  const {
    addResultsPrimaryButton,
    startTimerButton,
    deleteButton,
    markAsTestedButton,
    confirmButton,
    resendButton,
    previousStageButton,
    generateCertificateButton,
    addResultsSecondaryButton,
    downloadCertificateButton,
  } = buttons;
  const { generateCertificateOptions } = getActionOptions(handlers);
  const { downloadCertificate } = useFeatureFlagsHealthcheck();

  const contextMenuProps = {
    menuButton: ThreeDotsButton,
    'data-testid': 'healthcheck-buttons-container',
  };

  const contextMenuGenerateCertificateProps = {
    menuButton: GenerateCertificateDropdownMenuButton,
    'data-testid': 'healthcheck-generate-certificate-buttons-container',
  };

  switch (state) {
    case 'pending':
      return testType === 'antigen' ? (
        <>
          {deleteButton}
          {showPreviousStageAndGenerateCertificateButtons && {
            previousStageButton,
          }}
          {addResultsSecondaryButton}
        </>
      ) : (
        <>
          {deleteButton}
          {showPreviousStageAndGenerateCertificateButtons && {
            previousStageButton,
          }}
          {addResultsPrimaryButton}
        </>
      );
    case 'done':
      return isCertificateGenerated ? (
        <>
          {downloadCertificate && downloadCertificateButton}
          {isResendCertificate && resendButton}
          {showPreviousStageAndGenerateCertificateButtons && {
            generateCertificateButton,
          }}
          {isCertificateTypeDropdownShow && (
            <ContextMenu
              options={generateCertificateOptions}
              {...contextMenuGenerateCertificateProps}
            />
          )}
        </>
      ) : (
        <>
          {showPreviousStageAndGenerateCertificateButtons && {
            generateCertificateButton,
          }}
          {isCertificateTypeDropdownShow && (
            <ContextMenu
              options={generateCertificateOptions}
              {...contextMenuGenerateCertificateProps}
            />
          )}
        </>
      );
    case 'confirmed':
      return testType === 'antigen' ? (
        <>
          {deleteButton}
          {showPreviousStageAndGenerateCertificateButtons && {
            previousStageButton,
          }}
          {addResultsSecondaryButton}
          {startTimerButton}
        </>
      ) : (
        <>
          {deleteButton}
          {showPreviousStageAndGenerateCertificateButtons && {
            previousStageButton,
          }}
          {markAsTestedButton}
        </>
      );
    case 'ordered':
    default:
      return (
        <>
          {deleteButton}
          {confirmButton}
        </>
      );
  }
};

export default ActionsDesktop;
